import React from 'react';
import { DeliveryItem } from '../customerDashboardTypes';
import styles from './UpcomingDeliveries.module.css';

interface UpcomingDeliveriesProps {
  deliveries: DeliveryItem[];
}

export const UpcomingDeliveries: React.FC<UpcomingDeliveriesProps> = ({ deliveries }) => {
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Upcoming Deliveries</h3>
      <div className={styles.list}>
        {deliveries.map((delivery) => (
          <div key={delivery.id} className={styles.item}>
            <div className={styles.info}>
              <span className={styles.invoiceNumber}>{delivery.invoiceNumber}</span>
              <span className={styles.date}>{delivery.dateLabel}</span>
            </div>
            <span className={`${styles.badge} ${styles[delivery.status === 'In Transit' ? 'inTransit' : 'scheduled']}`}>
              {delivery.status}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
